import { scenariosView, futureSelectionView } from './ScenarioViews';
import { lensesView } from './LensViews';
import { pivotPointsView, solutionsView } from './PivotSolutionViews';

// View name → {Tile, Detail} summary views in the module's own visual idiom
// (specs/workshop-dashboard.md → "Module summary views — design guidance").
// A module's manifest names its view in `dashboard.view` (#1500); the
// dashboard payload carries it. A module without a view renders the generic
// headline + bars; one without data renders its name in large type
// (ProgressTile).
export const SUMMARY_VIEWS = {
  scenarios: scenariosView,
  futureSelection: futureSelectionView,
  lenses: lensesView,
  pivotPoints: pivotPointsView,
  solutions: solutionsView,
};

